import type { ReactNode } from "react";
import { forwardRef } from "react";
import { Icons } from "widgets";

import type { TileProps } from "@/modules/core/components/Tile.tsx";
import { Tile } from "@/modules/core/components/Tile.tsx";

interface GenomeViewTileProps extends Pick<TileProps, "title" | "footNote" | "to" | "tooltip"> {
  children?: ReactNode; // temporary as there is a known bug in the @types definitions with forwardRef
}

const SyntenyViewTile = forwardRef<HTMLDivElement, GenomeViewTileProps>(function SyntenyViewTile(props, ref) {
  return (
    <Tile
      {...props}
      type={"Synteny View"}
      icon={<img src={Icons.Tiles.GenomeViewer} width={24} height={30} alt={"genome viewer icon"} />}
      ref={ref}
    />
  );
});

export { SyntenyViewTile };
